/* ••[1]••••••••••••••••••••••••• EventCarousel.ts •••••••••••••••••••••••••••••• */

type EventCarouselItem = {
  thumbnail?: string;
  nodeElement?: HTMLElement;
  link?: string;
};

type EventCarousel = {
  items: Array<EventCarouselItem>;
};

function validatedEventCarouselItem(
  eventCarouselItem: EventCarouselItem
): EventCarouselItem | null {
  if (
    ("thumbnail" in eventCarouselItem &&
      typeof eventCarouselItem.thumbnail === "string") ||
    ("nodeElement" in eventCarouselItem &&
      typeof eventCarouselItem.nodeElement === "object")
  ) {
    return eventCarouselItem;
  }

  return null;
}

function validatedEventCarouselItems(
  eventCarouselItems: Array<EventCarouselItem>
): Array<EventCarouselItem> {
  if (Array.isArray(eventCarouselItems)) {
    const validEventCarouselItems: Array<EventCarouselItem> = [];

    for (const eventCarouselItem of Object.keys(eventCarouselItems)) {
      if (validatedEventCarouselItem(eventCarouselItems[+eventCarouselItem])) {
        validEventCarouselItems.push(eventCarouselItems[+eventCarouselItem]);
      }
    }

    return validEventCarouselItems;
  }

  return [];
}

export {
  EventCarouselItem,
  validatedEventCarouselItem,
  validatedEventCarouselItems,
  EventCarousel,
};
